import React from 'react';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

import { useAdminGetInvitationById } from '../../hooks/admin-get-invitation-by-id.hook';
import { ADMIN_INVITATIONS_APP_PATHS } from '../../constants/invitations-app-paths.constants';
import { InvitationDetailsHeader } from '../../components/Containers/InvitationDetailsHeader.component';
import { InvitationSummaryCards } from '../../components/Containers/InvitationSummaryCards.component';
import { InvitationOrdersSection } from '../../components/Containers/InvitationOrdersSection.component';
import { UserContactsTable } from '../../../users/components/Tables/UserContactsTable.component';
import { NotFoundState } from '../../../shared/components/States/NotFoundState.component';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',

    '& > h4': {
      margin: 0,
      opacity: 0.7,
    },
  },
});

export default function AdminInvitationDetailsView() {
  const classes = useStyles();
  const { invitationId } = useParams<{ invitationId: string }>();

  const { isLoading, invitation } = useAdminGetInvitationById({ invitationId });

  return (
    <section className={classes.root}>
      {isLoading && <Skeleton variant="rect" animation="wave" height={92} />}
      {!isLoading && !invitation && (
        <NotFoundState
          title="Invitation introuvable"
          backLabel="Retour aux invitations"
          backTo={ADMIN_INVITATIONS_APP_PATHS.INVITATIONS_LIST}
        />
      )}
      {!isLoading && invitation && (
        <React.Fragment>
          <InvitationDetailsHeader invitation={invitation} />
          <InvitationSummaryCards invitation={invitation} />
          <section className={classes.section}>
            <h4>Commandes</h4>
            <InvitationOrdersSection invitationId={invitation.id} />
          </section>
          <section className={classes.section}>
            <h4>Contacts</h4>
            <UserContactsTable
              contacts={invitation.contacts}
              isLoading={false}
              ariaLabel="Contacts de l'invitation"
              maxHeight="50svh"
            />
          </section>
        </React.Fragment>
      )}
    </section>
  );
}
